import { useLoggedOutSuppliersPageBrandsSearchRequest } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageBrandsSearchRequest";
import { logAssert } from "@faire/web--source/common/logging";
import { QueryParameters as BrandSearchParameters } from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get";
import { getQueryKey } from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get-hooks";
import React, { createContext, useContext } from "react";

export const LoggedOutSuppliersBrandsSearchRequestContext = createContext<
  | {
      request: BrandSearchParameters;
      requestKey: ReturnType<typeof getQueryKey>;
    }
  | undefined
>(undefined);

export const useLoggedOutSuppliersBrandsSearchRequestContext = () => {
  const data = useContext(LoggedOutSuppliersBrandsSearchRequestContext);
  logAssert(!!data?.request, "Suppliers' page request is undefined");
  logAssert(!!data?.requestKey, "Suppliers' page requestKey is undefined");
  return data;
};

export const LoggedOutSuppliersBrandsSearchRequestProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { request, requestKey } =
    useLoggedOutSuppliersPageBrandsSearchRequest();
  return (
    <LoggedOutSuppliersBrandsSearchRequestContext.Provider
      value={{ request, requestKey }}
    >
      {children}
    </LoggedOutSuppliersBrandsSearchRequestContext.Provider>
  );
};
